export default "__VITE_ASSET__eIRr8W_G__"